import { CreateEquipment, Equipment } from '@/generated';
import { equipmentApi } from '@/generated/clients';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './query-hooks';

const refreshChannel = new BroadcastChannel('equipment-refresh');

export const useCreateEquipment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (createEquipmentDTO: CreateEquipment) => equipmentApi.equipmentCreate({ createEquipment: createEquipmentDTO }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.Equipment] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useUpdateEquipment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updateEquipment: Equipment) => equipmentApi.equipmentUpdate({ equipment: updateEquipment }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.Equipment] });
      refreshChannel.postMessage('refresh');
    },
  });
};

export const useDeleteEquipment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (equipmentId: string) => equipmentApi.equipmentDelete({ equipmentId }),
    onSuccess: (_, dto) => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.Equipment] });
      refreshChannel.postMessage('refresh');
    },
  });
};
